<script lang="ts">
  import * as slider from '@zag-js/slider';
  import { normalizeProps, useMachine } from '@zag-js/svelte';
  import { stack } from '@agapi/ui/panda/patterns';
  import { rangeSliderStyles } from './range-slider.styles';
  import type { RangeSliderProps } from './range-slider.types';

  const {
    minStepsBetweenThumbs = 1,
    origin = 'start',
    thumbAlignment = 'contain',
    unitPosition = 'after',
    value,
    ...restProps
  }: RangeSliderProps = $props();

  const id = $props.id();

  const service = useMachine(slider.machine, {
    ...restProps,
    id,
    minStepsBetweenThumbs,
    origin,
    thumbAlignment,
    defaultValue: value
  });

  const classes = rangeSliderStyles();

  const api = $derived(slider.connect(service, normalizeProps));

  export const clearAll = () => {
    const min = api.getThumbMin(0);
    const max = api.getThumbMax(1);
    api.setValue([min, max]);
  };
</script>

<div {...api.getRootProps()} class={classes.root}>
  <div class={stack({ flexDirection: 'row', justifyContent: 'space-between' })}>
    <!-- svelte-ignore a11y_label_has_associated_control -->
    <label {...api.getLabelProps()} class={classes.label}>
      {restProps.label}
    </label>
    <span {...api.getValueTextProps} class={classes.valueText}>
      {#each api.value as value, index}
        {unitPosition === 'before' ? restProps.unit : ''}
        {value}
        {unitPosition === 'after' ? restProps.unit : ''}
        {index === api.value.length - 1 ? '' : ' - '}
      {/each}
    </span>
  </div>

  <div {...api.getControlProps()} class={classes.control}>
    <div {...api.getTrackProps()} class={classes.track}>
      <div {...api.getRangeProps()} class={classes.range}></div>
    </div>
    {#each api.value as _, index}
      <div {...api.getThumbProps({ index })} class={classes.thumb}>
        <input {...api.getHiddenInputProps({ index })} />
      </div>
    {/each}
  </div>
</div>
